import { IGlobalSettings, ISettingsAndProfile } from "../types/Settings.types";
import apiFetch from './index';

export async function getSettings(abortController: AbortController) {
    const response = await apiFetch(`/api/settings`, {
        headers: {
            Accept: 'application/json'
        },
        credentials: 'include',
        signal: abortController.signal
    });
    if (response.ok) {
        return await response.json() as ISettingsAndProfile;
    }
}

export async function saveSettings(settings: IGlobalSettings) {
    const response = await apiFetch(`/api/settings`, {
        headers: {
            Accept: 'application/json',
            "Content-Type": 'application/json'
        },
        body: JSON.stringify(settings),
        credentials: 'include',
        method: 'POST'
    });
    if (response.ok) {
        return true;
    } else {
        return new Error("Unable to load settings: " + response.statusText);
    }
}